import { Box } from "@mui/material";
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import CallIcon from '@mui/icons-material/Call';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';

import useDisplayDate from "../../hooks/Date/useDisplayDate";


const useCollectionColumns = (onCellClick) => {
  const { formatDate } = useDisplayDate();

  return [
    { accessorKey: 'collectionID', header: 'Collection ID',size: 200},
      { accessorKey: 'customerID', header: 'Customer ID',size: 200,},
      { accessorKey: 'leadID', header: 'Lead Id' },
      { accessorKey: 'loanNo', header: 'Loan No.'},
      { accessorKey: 'collectedAmount', header: 'Collected Amount',size: 240,
        accessorFn: (row) => {
          const value = row.collectedAmount;
          const isNumeric = !isNaN(value) && value !== null && value !== '';
          return(
            <Box display="flex" alignItems="center">
                      {isNumeric && <CurrencyRupeeIcon color="secondary" />}
                      {value}
            </Box>
          )
          
        }
      },
      { accessorKey: 'penaltyAmount', header: 'Penalty Amount',size: 220},
      { accessorKey: 'collectedMode', header: 'Collected Mode',size: 220},
      { accessorKey: 'collectedDate', header: 'Collected Date',size: 220,accessorFn: row => formatDate(row.collectedDate)  },
      { accessorKey: 'referenceNo', header: 'Reference No.',size: 200 },
      { accessorKey: 'discountAmount', header: 'Discount Amount',size: 230 },
      { accessorKey: 'settlemenAmount', header: 'Settlement Amount',size: 230},
      { accessorKey: 'status', header: 'Status',},
      { accessorKey: 'remark', header: 'Remark',},
      { accessorKey: 'createdDate', header: 'Created Date',size: 220,accessorFn: row => formatDate(row.createdDate)},
       { accessorKey: 'collectionStatus', header: 'Collection Status',size: 220,},
       { accessorKey: 'collectionStatusByName', header: 'Collection Status Name',size: 270,},
       { accessorKey: 'collectionStatusByRole', header: 'Collection Status Role',size: 270,},
       { accessorKey: 'approvedDate', header: 'Approved Date',accessorFn: row => formatDate(row.approvedDate),size: 220 },
       { accessorKey: 'orderID', header: 'Order ID' },
       { accessorKey: 'excess_amount', header: 'Excess Amount',size: 220 },
       { accessorKey: 'discount_waiver', header: 'Discount Waiver',size: 220 },
       { accessorKey: 'discount_waiver_amount', header: 'Discount Waiver Amount',size: 270 },
      { accessorKey: 'refund_utr_no', header: 'Refund Utr No',size: 200 },

      { accessorKey: 'collectedByName', header: 'Collected By Name',size: 250 },
      { accessorKey: 'collectedByRole', header: 'Collected By Role',size: 250 },
      


  ];
};

export default useCollectionColumns;
